import { Controller } from '@hotwired/stimulus'

const SCROLL_KEY = 'readingTrackerScrollY'
const RESTORE_KEY = 'readingTrackerShouldRestore'
const SCROLL_TO_WEEKLY_KEY = 'readingTrackerScrollToWeekly'

const markReadingTrackerRestore = () => {
  sessionStorage.setItem(RESTORE_KEY, 'true')

  if (sessionStorage.getItem(SCROLL_KEY) === null) {
    sessionStorage.setItem(SCROLL_TO_WEEKLY_KEY, 'true')
  }
}

/*
 * Used on links that navigate to the reading tracker (e.g. Children page
 * "Reading tracker →" button). Marks the next dashboard visit so scroll is
 * restored or the weekly progress section is brought into view.
 */
export default class extends Controller {
  connect() {
    this.element.addEventListener('click', markReadingTrackerRestore)
  }

  disconnect() {
    this.element.removeEventListener('click', markReadingTrackerRestore)
  }
}
